import { Http,RequestOptions ,Headers,Response} from '@angular/http';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { Injectable,Component } from '@angular/core';
import { APPCONFIG } from '../config';
import { Observable } from 'rxjs/Observable';

import 'rxjs/add/operator/map';
import {HttpHeaders} from "@angular/common/http";


@Injectable()
export class ApiBilling {
  // url: string = APPCONFIG[APPCONFIG.ENVIRONMENT+"_ApiURL_billing"];
  // url: string = APPCONFIG.ApiURL_billing;
    url:String;
  constructor(public http: Http) {
    this.setURLS()
  }
  get(endpoint: string, params?: any, reqOpts?: any):Observable<Response> {

    if (!reqOpts) {
      reqOpts =new RequestOptions();
    }

   // {headers: new HttpHeaders({'Content-Type': 'application/json'})}
    // Support easy query params for GET requests
    if (params) {
      reqOpts.params = new URLSearchParams();
      for (let k in params) {
        reqOpts.params.set(k, params[k]);
      }
    }

    return this.http.get(this.url + '/' + endpoint, reqOpts);
    // return this.http.get('http://localhost:8088/api/v1' + '/' + endpoint, reqOpts);

  }

  post(endpoint: string, body: any, reqOpts?: any) {
    return this.http.post(this.url + '/' + endpoint, body, reqOpts);
  }

  put(endpoint: string, body: any, reqOpts?: any) {
    return this.http.put(this.url + '/' + endpoint, body, reqOpts);
  }

  delete(endpoint: string, reqOpts?: any) {
    return this.http.delete(this.url + '/' + endpoint, reqOpts);
  }

  patch(endpoint: string, body: any, reqOpts?: any) {
    return this.http.put(this.url + '/' + endpoint, body, reqOpts);
  }


  private setURLS() {
    this.url = localStorage.getItem("billingApiUrl");
    // this.url = APPCONFIG.ApiURL_billing;
  }

  checkIsLicensedSubscribedAndLimit(){

  }
}






// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/providers/api.billing.ts